// extracted by css-extract-rspack-plugin
export default {"markdown":"ProgramOverview_markdown__l6QZU"};